// Vérifier que CryptoJS est chargé
if (typeof CryptoJS === 'undefined') {
    console.error('CryptoJS non disponible ! Assurez-vous que le script est chargé.');
}

function calculateChecksum(params, token) {
    const vars = [
        params.categoryId,
        params.equipmentState,
        params.equipmentType,
        params.image,
        params.link,
        params.model,
        params.priceInCts,
        params.cashPriceInCts,
        params.reference || '',
        params.shippingDeliveryTimeInDays,
        params.shippingType,
        params.shippingUnitaryCostInCts,
        params.trademark
    ];
    
    const message = vars.join('&');
    console.log('String pour checksum:', message);
    
    // Utiliser CryptoJS comme Mypangee
    const hash = CryptoJS.HmacSHA512(message, CryptoJS.enc.Hex.parse(token));
    const checksum = hash.toString(CryptoJS.enc.Hex).toUpperCase();
    
    console.log('Checksum calculé:', checksum);
    return checksum;
}

async function getShoppingCart(params) {
    // Token de PRODUCTION
    const API_TOKEN = "64CD6CD3422ABCA4A9DCF85FCF3B76DD";
    
    // Calculer le checksum avec CryptoJS
    const checksum = calculateChecksum(params, API_TOKEN);
    
    // PAS de X-API-Token dans les headers !
    const myHeaders = new Headers({
        "Content-Type": "application/json"
    });

    const payload = JSON.stringify({
        "items": [{
            "categoryId": params.categoryId,
            "equipmentState": "NEW",
            "equipmentType": "PRODUCT",
            "image": params.image,
            "link": params.link,
            "model": params.model,
            "priceInCts": params.priceInCts,
            "cashPriceInCts": params.cashPriceInCts,
            "reference": params.reference || '',
            "shippingDeliveryTimeInDays": 7,
            "shippingType": "HOME_DELIVERY",
            "shippingUnitaryCostInCts": params.shippingUnitaryCostInCts,
            "trademark": "BIOW",
            "checksum": checksum,
            "quantity": params.quantity
        }],
        "purchaseKind": "RENT_PRODUCT_WITH_REDEMPTION",
        "durationInMonths": 36
    });

    console.log("Payload complet envoyé:", JSON.parse(payload));

    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: payload
    };

    try {
        // URL de PRODUCTION (sans .dev)
        const response = await fetch("https://proxy.mypangee.com/api/v1/space/594/shoppingcart/addShoppingCart", requestOptions);
        
        const text = await response.text();
        console.log('Réponse reçue:', text);

        if (text.startsWith('http')) {
            console.log('Redirection vers:', text);
            window.location.href = text;
            return text;
        } else {
            try {
                const json = JSON.parse(text);
                if (json.url || json.redirectUrl) {
                    window.location.href = json.url || json.redirectUrl;
                    return json.url || json.redirectUrl;
                }
                console.error('Réponse API:', json);
            } catch (e) {
                console.error('Réponse inattendue:', text);
            }
        }
    } catch (error) {
        console.error('Erreur:', error);
        throw error;
    }
}